module.exports = __webpack_public_path__ + "static/cricli2-56f9ef7746a2948424b3ec58c27df304.gif";